/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

export type RiskScoreRevealType = typeof RiskScoreRevealType[keyof typeof RiskScoreRevealType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RiskScoreRevealType = {
  'cancer-reveal': 'cancer-reveal',
  'blood-reveal': 'blood-reveal',
} as const;
